<template>
  <h4 class="text-left mb-2"><slot></slot></h4>
  <hr class="mb-3" />
</template>
<script>
export default {
  name: "TitleHeader"
};
</script>
